import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableContainer, TableHead, Paper, TableRow } from '@mui/material';
import Spinner from '@/components/UI/Spinner/Spinner';
import styles from './UserRow/UserRow.module.scss';

export type UserColumnFilters = {
  lastName: string,
  firstName: string,
  department: string,
  userCode: string,
};

type TableListComponent = {
  list: any;
  RowComponent: React.FC<any>;
  whithLastRow?: boolean;
  handleRowClick?: (element: any) => void; // eslint-disable-line no-unused-vars
  handleCheckAll?: () => void;
  filterTable: (column, value) => void; // eslint-disable-line no-unused-vars
  columnFilters?: UserColumnFilters;
  isFilter?: boolean;
  noResultsMessage?: string;
  loading?: boolean;
};

const TableList: React.FC<TableListComponent> = ({ list, RowComponent, whithLastRow, handleRowClick, handleCheckAll, filterTable,
  columnFilters, isFilter, noResultsMessage, loading = false }) => {
  const { t } = useTranslation();
  let rows;

  if (list === null) {
    rows = <RowComponent element={t('loading')} />;
  } else if (list?.length === 0) {
    rows = <RowComponent element={t(noResultsMessage || 'noResults')} />;
  } else {
    rows = list?.map((elem, index) => (
      <RowComponent
        element={elem}
        key={elem.userCode || index}
        handleRowClick={handleRowClick}
      />
    ));
  }

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <RowComponent
            isHeader
            handleCheckAll={handleCheckAll}
          />
          {isFilter && (
            <RowComponent
              isFilter
              filterTable={(column, value) => filterTable(column, value)}
              columnFilters={columnFilters}
            />
          )}
        </TableHead>
        {loading && <TableRow className={styles.TableLoader}><div className={styles.Spinner}><Spinner isVisible /></div></TableRow>}
        <TableBody>
          {!loading && (
            <>
              {rows}
              {whithLastRow && <RowComponent isLastRow />}
            </>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableList;
